import { Layout } from "antd";
import Logo from "assets/images/logo.png";
import dayjs from "dayjs";

const { Footer } = Layout;

const PublicFooter = ({ onClick }) => {
  return (
    <Footer onClick={onClick} className="p-3 bg-blue-900">
      <div className="flex flex-col gap-1 items-center">
        <span className="text-white">Powered By</span>
        <a
          href="https://crm.id/"
          target="_blank"
          rel="noopener noreferrer"
          className="text-link-primary"
        >
          <img width={70} src={Logo} alt="Logo" />
        </a>
        <span className="text-white">
          &copy;{` ${dayjs().format("YYYY")} Kledo CRM. All rights reserved.`}
        </span>
      </div>
    </Footer>
  );
};

export default PublicFooter;
